import React, { useEffect, useState } from 'react';
import {
  SdmSpacer,
  SdmTypography,
  SdmCheckbox,
  SdmTextButton,
} from 'components';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { styled } from '@material-ui/core/styles';
import { theme } from 'theme';
import { DialogContent, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { Controller, useForm } from 'react-hook-form';

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

const CustomFormTextField = withStyles({
  root: {
    width: '90%',
    marginLeft: 8,
    '& .MuiFormControl-root': {
      width: '95%',
    },
    '& label.Mui-focused': {
      color: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:before': {
      borderBottom: `2px solid ${theme.colors.primary.black}`,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Suisse-Intl',
      fontSize: 26,
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Suisse-Intl',
      color: `${theme.colors.primary.black}`,
      fontSize: 21,
    },
  },
})(TextField);

const defaultValue = {
  id: undefined,
  givenName: undefined,
  familyName: undefined,
  // email: undefined,
  // phone: undefined,
  role: undefined,
};

const textfieldInputKeys = [
  'givenName',
  'familyName',
  // 'email',
  // 'phone',
  'role',
];

const FormDialog = ({ onClose, onAgree, i18n, isSmDown, data, onDelete }) => {
  // States
  const [selectedLanguages, setSelectedLanguages] = useState([
    { value: 'it', isChecked: false },
    { value: 'en', isChecked: false },
    { value: 'fr', isChecked: false },
    { value: 'ru', isChecked: false },
    { value: 'ch', isChecked: false },
    { value: 'de', isChecked: false },
  ]);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [id, setId] = useState('');
  // Hooks
  const { handleSubmit, errors, control, watch, reset } = useForm({
    defaultValues: defaultValue,
  });

  // Effects
  useEffect(() => {
    if (data && data?.selectedMember?.id) {
      reset(data.selectedMember);
      setId(data.selectedMember.id);
      setSelectedLanguages(
        languagesAvailable.map((l) => {
          const element = data.selectedMember.languages.find(
            (lang) => lang === l.value
          );
          return element
            ? {
                value: element,
                isChecked: true,
              }
            : { value: l.value, isChecked: false };
        })
      );
      if (data?.context && data?.context === 'view') {
        setIsReadOnly(true);
      }
    }
  }, [data]);

  // Constants
  const languagesAvailable = [
    { label: i18n.fields.languages.it, value: 'it' },
    { label: i18n.fields.languages.en, value: 'en' },
    { label: i18n.fields.languages.fr, value: 'fr' },
    { label: i18n.fields.languages.ru, value: 'ru' },
    { label: i18n.fields.languages.ch, value: 'ch' },
    { label: i18n.fields.languages.de, value: 'de' },
  ];

  // Functions
  const handleOverflowBody = () => {
    const bodyStatus = document.body.getAttribute('style');
    if (bodyStatus.includes('overflow: hidden')) {
      document.body.style.overflow = 'visible';
      document.body.style.paddingTop = 79;
    }
  };

  const handleClose = () => {
    handleOverflowBody();
    onClose && onClose();
  };

  const handleCheckSelection = (data) => {
    const alreadySelected = [...selectedLanguages];
    const element = alreadySelected.find((c) => c.value === data.checkBox);
    const filtered = alreadySelected.filter((c) => c.value !== data.checkBox);
    const update = { ...element, isChecked: data.value };
    const updateArray = [...filtered, update];
    setSelectedLanguages(updateArray);
  };

  const customSubmit = (data) =>
    onAgree &&
    onAgree({
      ...data,
      ...(id && {
        id: id,
      }),
      languages: selectedLanguages
        .filter((l) => l.isChecked)
        .map((l) => l.value),
    });

  const handleDelete = () => onDelete?.(data.selectedMember.id);

  // Renders
  const renderError = (key, labelKey) => {
    if (errors[key] && errors[key]?.type === 'required')
      return (
        <SdmTypography
          style={{ color: `${theme.colors.primary.red}`, marginTop: -15 }}
          variant={'textBold'}
        >
          {i18n.fields[labelKey ? labelKey : key].error}
        </SdmTypography>
      );
    return null;
  };

  const name = watch('givenName');
  const surname = watch('familyName');

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={1080}
      PaperProps={{
        style: {
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 80,
          paddingBottom: 80,
          maxWidth: 900,
        },
      }}
    >
      <div
        tabIndex={0}
        role="button"
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: 24,
          right: 24,
        }}
      >
        <StyledIconButton>
          <CloseIcon fontSize={isSmDown ? 'large' : 'small'} />
        </StyledIconButton>
      </div>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            {/* <SdmTypography
              variant={'h3'}
              style={{ textTransform: 'uppercase' }}
              margin={0}
              textAlign={'center'}
            >
              {i18n.subtitle}
            </SdmTypography> */}
            {/* <SdmSpacer height={20} /> */}
            <SdmTypography variant={'h1'} margin={0} textAlign={'center'}>
              {isReadOnly ? i18n.readOnlyTitle : i18n.title}
            </SdmTypography>
            <form onSubmit={handleSubmit(customSubmit)}>
              <Grid container style={{ width: '100%' }}>
                <SdmSpacer height={40} />
                <Grid item xs={12}>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <div
                      style={{
                        width: isSmDown ? 80 : 120,
                        height: isSmDown ? 80 : 120,
                        backgroundColor: '#D8D8D8',
                        borderRadius: 100,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {(name || surname) && (
                        <SdmTypography
                          variant={isSmDown ? 'h4Regular' : 'h1Regular'}
                          style={{
                            width: '100%',
                            color: theme.colors.primary.black,
                          }}
                        >
                          {name?.charAt(0).toUpperCase()}{' '}
                          {surname?.charAt(0).toUpperCase()}
                        </SdmTypography>
                      )}
                    </div>
                  </div>
                  <SdmSpacer height={40} />
                </Grid>
                {textfieldInputKeys.map((field, idx) => (
                  <Grid item key={idx} xs={12} md={6}>
                    <Controller
                      name={field}
                      control={control}
                      defaultValue=""
                      rules={{ required: true }}
                      render={(props) => (
                        <CustomFormTextField
                          onChange={(e) => {
                            props.onChange(e.target.value);
                          }}
                          value={props.value}
                          id={`${field}-required`}
                          label={`${i18n.fields[field].label}${
                            !isReadOnly ? '*' : ''
                          }`}
                          style={{ marginBottom: 10 }}
                          disabled={isReadOnly}
                        />
                      )}
                    />
                    {renderError(field)}
                  </Grid>
                ))}
                {!isReadOnly ? (
                  <>
                    <SdmSpacer height={40} />
                    <Grid item xs={12}>
                      <SdmTypography variant={'h2Regular'}>
                        {i18n.fields.languagesField.label}*
                      </SdmTypography>
                    </Grid>
                    <SdmSpacer height={20} />
                    {languagesAvailable.map((p, idx) => (
                      <Grid item xs={12} md={2} key={idx}>
                        <SdmCheckbox
                          onChange={(e) => {
                            handleCheckSelection({
                              checkBox: p.value,
                              value: e.target.checked,
                            });
                          }}
                          value={p.value}
                          isSelected={
                            selectedLanguages.find((c) => c.value === p.value)
                              ?.isChecked || false
                          }
                          label={p.label}
                          labelPlacement={'end'}
                          customFont={'h4Regular'}
                          style={{ marginLeft: 20 }}
                        />
                      </Grid>
                    ))}
                  </>
                ) : (
                  <Grid item xs={12} md={6}>
                    <CustomFormTextField
                      value={data.selectedMember.languages
                        .map(
                          (l) =>
                            languagesAvailable.find((lang) => lang.value === l)
                              ?.label
                        )
                        .join(' - ')}
                      label={`${i18n.fields.languagesField.label}`}
                      style={{ marginBottom: 10 }}
                      disabled={true}
                    />
                  </Grid>
                )}
                <SdmSpacer height={30} />
                <Grid item xs={12}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: isSmDown ? 'center' : 'flex-end',
                      // paddingRight: 75,
                    }}
                  >
                    <SdmTextButton
                      onClick={handleClose}
                      text={i18n.btn.cancel}
                      height={30}
                      style={{ width: 158, height: 50, marginRight: 10 }}
                      variant={'red'}
                      textVariant={'h4Regular'}
                    />
                    <SdmTextButton
                      type={!isReadOnly ? 'submit' : 'button'}
                      text={!isReadOnly ? i18n.btn.save : i18n.btn.delete}
                      height={30}
                      style={{ width: 158, height: 50, marginLeft: 10 }}
                      variant={'redFill'}
                      textVariant={'h4Regular'}
                      disabled={
                        !isReadOnly &&
                        selectedLanguages.every((c) => !c.isChecked)
                      }
                      onClick={() => isReadOnly && handleDelete()}
                    />
                  </div>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default FormDialog;
